/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * User Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User group schema for update
 * @export
 * @interface UserGroupUpdate
 */
export interface UserGroupUpdate {
    /**
     * @type {string}
     * @memberof UserGroupUpdate
     */
    name: string;
    /**
     * @type {string}
     * @memberof UserGroupUpdate
     */
    address?: string;
    /**
     * @type {string}
     * @memberof UserGroupUpdate
     */
    phone_number?: string;
    /**
     * @type {number}
     * @memberof UserGroupUpdate
     */
    client_access_code?: number;
}
